import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-nepal-market-study',
  templateUrl: './nepal-market-study.component.html',
  styleUrls: ['./nepal-market-study.component.css']
})
export class NepalMarketStudyComponent implements OnInit {
  isLoader = false;
  body = true
  space = " "
  Output:any = []

  constructor(private service:ServiceService, private route:ActivatedRoute, private router:Router) { }

  baseUrl = this.service.ReturnBase()

  //excel Export For CustomerKyc
  excelExport() {
    var orderTable = document.getElementById('MarketStudy');
    var wb = XLSX.utils.table_to_book(orderTable, { sheet: "sheet1" });

    return XLSX.writeFile(wb, ('Nepal Wood Market Study.' + ('xlsx')));


  }
  


  ngOnInit(): void {
    this.service.viewnepalwoodmarketstudy().subscribe((res)=>{
      this.Output = res.data
      console.log("data=", res);
      
    })
    
    
  }

}
